import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			cardProps: {
				props: {},
				queries: {
					title: {
						queryOptionsType: 'none',
						value: 'Fund Documents',
					},
				},
			},
			disclaimersProps: {
				props: {
					hasHtmlContent: true,
					disclaimers: [],
				},
				queries: {
					disclaimers: [
						{
							text: {
								queryOptionsType: 'disclaimers',
								key: 'document_library_disclaimer',
							},
						},
					],
				},
			},
			name: '',
			downloadAllLabel: 'Download All',
			showDownloadAll: true,
			hideListsWhenNoDocuments: true,
			noDocumentsText: {
				queryOptionsType: 'none',
				value: '<p>No documents available</p>',
			},
			showCopyButton: false,
			copyButtonProps: {
				text: 'Copy',
			},
			documentLists: [
				{
					breakpoints: [
						{
							size: 'medium',
							modifier: 'down',
							props: {
								showPill: true,
								hideLabel: true,
								dropdownLabelType: 'icon',
							},
						},
						{
							size: 'large',
							modifier: 'up',
							props: {
								showPill: false,
								hideLabel: false,
							},
						},
					],
					allowSelection: false,
					heading: 'General Documents',
					availableLabel: '{available} languages available',
					documentQueries: [
						{
							queryOptionsType: 'documents',
							entityType: 'CLSS',
							collectionItemConditional: {
								conditions: [
									{
										field: 'inferred.Category',
										operator: 'includes',
										value: 'General',
									},
								],
							},
						},
					],
					documentFields: [
						{
							name: 'isin',
							key: 'meta',
							childKey: 'isin',
						},
						{
							name: 'documentType',
							key: 'meta',
							childKey: 'document_type',
						},
					],
					groupingLabelAliases: [
						{
							source: 'KIID',
							replacement: 'Key Investor Information Document',
						},
					],
					listItemLabel: {
						queryOptionsType: 'response',
						key: 'cultureCode',
						transforms: [
							{
								transformOptionsType: 'alias',
								aliases: [
									{
										source: 'en-GB',
										replacement: 'English (United Kingdom)',
									},
									{
										source: 'en-IE',
										replacement: 'English (Ireland)',
									},
									{
										source: 'nl-NL',
										replacement: 'Dutch (Netherlands)',
									},
									{
										source: 'sv-SE',
										replacement: 'Swedish (Sweden)',
									},
									{
										source: 'da-DK',
										replacement: 'Danish (Denmark)',
									},
									{
										source: 'it-IT',
										replacement: 'Italian (Italy)',
									},
									{
										source: 'es-ES',
										replacement: 'Spanish (Spain)',
									},
									{
										source: 'de-CH',
										replacement: 'German (Switzerland)',
									},
									{
										source: 'en-CH',
										replacement: 'English (Switzerland)',
									},
									{
										source: 'en-DE',
										replacement: 'English (Germany)',
									},
									{
										source: 'en-AT',
										replacement: 'English (Austria)',
									},
								],
							},
						],
					},
					fileName: {
						value: '{sub:title}{sub:isin}',
						queryOptionsType: 'none',
						subQueries: [
							{
								queryId: 'title',
								queryOptionsType: 'response',
								key: 'title',
							},
							{
								queryId: 'isin',
								queryOptionsType: 'response',
								key: 'meta.isin.value',
							},
						],
					},
					grouping: 'documentType',
					hideWhenEmpty: true,
					pillProps: {
						value: '',
						priority: 'primary',
					},
					showCopyButton: true,
					copyButtonProps: {
						iconProps: {
							src: 'CopyLinkIcon.svg',
						},
					},
				},
				{
					allowSelection: true,
					heading: 'Legal Documents',
					availableLabel: '{available} languages available',
					hideLabel: true,
					documentQueries: [
						{
							queryOptionsType: 'documents',
							entityType: 'CLSS',
							collectionItemConditional: {
								conditions: [
									{
										field: 'inferred.Category',
										operator: 'includes',
										value: 'Legal',
									},
								],
							},
						},
					],
					documentFields: [
						{
							name: 'isin',
							key: 'meta',
							childKey: 'isin',
						},
						{
							name: 'documentType',
							key: 'meta',
							childKey: 'document_type',
						},
					],
					listItemLabel: {
						queryOptionsType: 'response',
						key: 'cultureCode',
						transforms: [
							{
								transformOptionsType: 'alias',
								aliases: [
									{
										source: 'en-GB',
										replacement: 'English (United Kingdom)',
									},
									{
										source: 'en-IE',
										replacement: 'English (Ireland)',
									},
									{
										source: 'nl-NL',
										replacement: 'Dutch (Netherlands)',
									},
									{
										source: 'sv-SE',
										replacement: 'Swedish (Sweden)',
									},
									{
										source: 'da-DK',
										replacement: 'Danish (Denmark)',
									},
									{
										source: 'it-IT',
										replacement: 'Italian (Italy)',
									},
									{
										source: 'es-ES',
										replacement: 'Spanish (Spain)',
									},
									{
										source: 'de-CH',
										replacement: 'German (Switzerland)',
									},
									{
										source: 'en-CH',
										replacement: 'English (Switzerland)',
									},
									{
										source: 'en-DE',
										replacement: 'English (Germany)',
									},
									{
										source: 'en-AT',
										replacement: 'English (Austria)',
									},
								],
							},
						],
					},
					fileName: {
						value: '{sub:title}{sub:isin}',
						queryOptionsType: 'none',
						subQueries: [
							{
								queryId: 'title',
								queryOptionsType: 'response',
								key: 'title',
							},
							{
								queryId: 'isin',
								queryOptionsType: 'response',
								key: 'meta.isin.value',
							},
						],
					},
					grouping: 'documentType',
					hideWhenEmpty: true,
				},
			],
			entityGrouping: {
				entitiesId: 'classes',
				heading: {
					props: {
						level: 2,
					},
					queries: {
						title: {
							queryOptionsType: "property",
							entityType: 'CLSS',
							code: 'full_share_class_name'
						}
					}
				}
			},
			useSpinner: true,
		},
	},
	// Key Documents Config
	// components: {
	// 	app: {
	// 		name: '',
	// 		// title: 'Key Documents',
	// 		// downloadAllLabel: 'Download All',
	// 		documentLists: [
	// 			{
	// 				allowSelection: false,
	// 				heading: 'Key Documents',
	// 				availableLabel: '{available} languages available',
	// 				documentQueries: [
	// 					{
	// 						queryOptionsType: 'documents',
	// 						entityType: 'CLSS',
	// 						collectionItemConditional: {
	// 							conditions: [
	// 								{
	// 									field: 'inferred.Category',
	// 									operator: 'includes',
	// 									value: 'Key',
	// 								},
	// 							],
	// 						},
	// 					},
	// 				],
	// 				documentFields: [
	// 					{
	// 						name: 'isin',
	// 						key: 'meta',
	// 						childKey: 'isin',
	// 					},
	// 					{
	// 						name: 'documentType',
	// 						key: 'meta',
	// 						childKey: 'document_type',
	// 					},
	// 				],
	// 				listItemLabel: {
	// 					queryOptionsType: 'response',
	// 					key: 'cultureCode',
	// 					transforms: [
	// 						{
	// 							transformOptionsType: 'alias',
	// 							aliases: [
	// 								{
	// 									source: 'en-GB',
	// 									replacement: 'English (United Kingdom)',
	// 								},
	// 								{
	// 									source: 'en-IE',
	// 									replacement: 'English (Ireland)',
	// 								},
	// 								{
	// 									source: 'nl-NL',
	// 									replacement: 'Dutch (Netherlands)',
	// 								},
	// 								{
	// 									source: 'sv-SE',
	// 									replacement: 'Swedish (Sweden)',
	// 								},
	// 								{
	// 									source: 'da-DK',
	// 									replacement: 'Danish (Denmark)',
	// 								},
	// 								{
	// 									source: 'it-IT',
	// 									replacement: 'Italian (Italy)',
	// 								},
	// 								{
	// 									source: 'es-ES',
	// 									replacement: 'Spanish (Spain)',
	// 								},
	// 								{
	// 									source: 'de-CH',
	// 									replacement: 'German (Switzerland)',
	// 								},
	// 								{
	// 									source: 'en-CH',
	// 									replacement: 'English (Switzerland)',
	// 								},
	// 							],
	// 						},
	// 					],
	// 				},
	// 				fileName: {
	// 					value: '{sub:title}{sub:isin}',
	// 					queryOptionsType: 'none',
	// 					subQueries: [
	// 						{
	// 							queryId: 'title',
	// 							queryOptionsType: 'response',
	// 							key: 'title',
	// 						},
	// 						{
	// 							queryId: 'isin',
	// 							queryOptionsType: 'response',
	// 							key: 'meta.isin.value',
	// 						},
	// 					],
	// 				},
	// 				grouping: 'documentType',
	// 			},
	// 		],
	// 	},
	// },
	assetOverrides: {
		base: {
			documentDownload: {
				icon: 'DownloadIcon.svg',
				spinner: 'SpinnerIcon.svg',
			},
		},
	},
};